export default "__VITE_ASSET__CMFh_D3k__"